// extracted by mini-css-extract-plugin
export var caseStudyContent = "flutterCaseStudy-module--caseStudyContent--0bfe2";
export var caseStudyLink = "flutterCaseStudy-module--caseStudyLink--21ba0";
export var contentLeft = "flutterCaseStudy-module--contentLeft--1b917";
export var contentRight = "flutterCaseStudy-module--contentRight--ed148";
export var contentRiht = "flutterCaseStudy-module--contentRiht--581d8";
export var healthCareCaseStudy = "flutterCaseStudy-module--healthCareCaseStudy--a3967";
export var mix_heading = "flutterCaseStudy-module--mix_heading--4a242";
export var quoteImage = "flutterCaseStudy-module--quoteImage--37a3b";